/* ripple+ BFCM Sampler buy box — one product, subscribe toggle, Skio plan picker.
   Every price comes from the product: plan prices from its selling plan allocations,
   one-time from the variant, the crossed-out figure from compare-at. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.spReady === '1') return;
    var cfgEl = root.querySelector('[data-sp-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.dataset.spReady = '1';
    cfg.plans = (cfg.plans || []).filter(Boolean);

    var fmt;
    try {
      fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency || 'USD', currencyDisplay: 'narrowSymbol' });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }
    function money(c) { return fmt.format(c / 100); }
    function moneyShort(c) { return c % 100 === 0 ? money(c).replace(/[.,]00$/, '') : money(c); }

    var el = {
      plan: root.querySelector('[data-sp-plan]'),
      toggle: root.querySelector('[data-sp-toggle]'),
      freq: root.querySelector('[data-sp-freq]'),
      atc: root.querySelector('[data-sp-atc]'),
      atcText: root.querySelector('[data-sp-atc-text]'),
      atcPill: root.querySelector('[data-sp-atc-pill]'),
      note: root.querySelector('[data-sp-note]'),
      error: root.querySelector('[data-sp-error]')
    };
    var state = { sub: cfg.subscribeByDefault !== false && cfg.plans.length > 0 };

    function plan() {
      var id = el.freq ? parseInt(el.freq.value, 10) : null;
      for (var i = 0; i < cfg.plans.length; i++) if (cfg.plans[i].id === id) return cfg.plans[i];
      return cfg.plans[0] || null;
    }
    function set(sel, text) { var n = root.querySelector(sel); if (n && n.textContent !== text) n.textContent = text; }
    function pct(was, now) { return was ? Math.round((was - now) / was * 100) : 0; }
    function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function freqText() {
      if (!el.freq || el.freq.selectedIndex < 0) return '';
      var p = plan();
      return p ? p.name.toLowerCase().replace(/^delivery\s+/, '') : '';
    }

    function render() {
      var p = plan();
      var planPrice = p ? p.price : cfg.price;
      var was = cfg.compareAt > planPrice ? cfg.compareAt : cfg.price;
      var on = state.sub && !!p;

      /* headline price and the bundle card always show the plan offer */
      set('[data-sp-head-now]', moneyShort(planPrice));
      set('[data-sp-head-was]', was > planPrice ? moneyShort(was) : '');
      var strong = root.querySelector('[data-sp-plan-strong]');
      if (strong) strong.textContent = (cfg.text.planStrong || '').replace('[pct]', pct(was, planPrice));
      set('[data-sp-item-was]', was > planPrice ? money(was) : '');
      set('[data-sp-item-now]', money(planPrice));
      set('[data-sp-total-was]', was > planPrice ? money(was) : '');
      set('[data-sp-total-now]', money(planPrice));
      var lock = root.querySelector('[data-sp-lock]');
      if (lock) lock.innerHTML = escapeHtml(lock.getAttribute('data-tpl').replace('[price]', moneyShort(planPrice))).replace(/\n/g, '<br>');
      var save = root.querySelector('[data-sp-save]');
      if (save) save.textContent = save.getAttribute('data-tpl').replace('[amount]', money(was - planPrice)).replace('[pct]', pct(was, planPrice));

      Array.prototype.forEach.call(root.querySelectorAll('[data-sp-on]'), function (n) { n.hidden = !on; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-sp-off]'), function (n) { n.hidden = on; });
      if (save && was <= planPrice) save.hidden = true;
      if (el.plan) el.plan.classList.toggle('is-off', !on);
      if (el.toggle) el.toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      if (el.freq) el.freq.disabled = !on;

      /* button: what this click actually charges */
      var charge = on ? planPrice : cfg.price;
      var saving = (cfg.compareAt || 0) - charge;
      if (!cfg.available) {
        el.atcText.textContent = cfg.text.soldOut;
        el.atcPill.hidden = true;
        el.atc.disabled = true;
      } else {
        el.atcText.textContent = cfg.text.atc + ' | ' + money(charge);
        el.atcPill.hidden = saving <= 0;
        el.atcPill.textContent = (cfg.text.atcSave || '').replace('[amount]', money(saving));
      }

      if (el.note) {
        var tpl = on ? el.note.getAttribute('data-sub') : el.note.getAttribute('data-off');
        el.note.innerHTML = escapeHtml((tpl || '')
          .replace(/\[price\]/g, money(charge))
          .replace('[compare]', money(cfg.compareAt || cfg.price))
          .replace('[freq]', freqText())).replace(/\n/g, '<br>');
      }
    }

    if (el.toggle) el.toggle.addEventListener('click', function () {
      if (!cfg.plans.length) return;
      state.sub = !state.sub;
      render();
    });
    if (el.freq) el.freq.addEventListener('change', render);

    function openCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      try {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') { window.Rebuy.SmartCart.show(); return; }
      } catch (e) {}
      var trigger = document.querySelector('a.cart-link, [data-cart-toggle], .js-cart-trigger');
      if (trigger) { trigger.click(); return; }
      window.location.href = cfg.routes.cart;
    }

    if (el.atc) el.atc.addEventListener('click', function () {
      if (el.atc.disabled) return;
      el.error.classList.remove('is-visible');
      var item = { id: cfg.variant, quantity: 1 };
      var p = plan();
      if (state.sub && p) item.selling_plan = p.id;
      el.atc.classList.add('is-loading');
      fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          el.atc.classList.remove('is-loading');
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || cfg.text.error);
          openCart();
        })
        .catch(function (err) {
          el.atc.classList.remove('is-loading');
          el.error.textContent = err.message || cfg.text.error;
          el.error.classList.add('is-visible');
        });
    });

    /* read more */
    var rm = root.querySelector('[data-sp-readmore]');
    if (rm) rm.addEventListener('click', function () { rm.closest('.sp-bb__desc').classList.add('is-open'); });

    /* in-page links (reviews) scroll smoothly */
    Array.prototype.forEach.call(root.querySelectorAll('[data-sp-scroll]'), function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var t = document.querySelector(href);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* gallery: native swipe, arrows wrap, progress bar follows the scroll */
    var track = root.querySelector('[data-sp-track]');
    if (track) {
      var slides = track.children;
      var bar = root.querySelector('[data-sp-progress]');
      var idx = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
      var go = function (i) {
        var n = slides.length;
        i = ((i % n) + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      };
      var prev = root.querySelector('[data-sp-prev]');
      var next = root.querySelector('[data-sp-next]');
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      if (bar) track.addEventListener('scroll', function () {
        var max = track.scrollWidth - track.clientWidth;
        var f = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (f * (slides.length - 1) * 100) + '%)';
      }, { passive: true });
    }

    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sp-root]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-sp-root]'), init);
  });
})();
